// extracted by mini-css-extract-plugin
export var addressFields = "_o2-0";
export var animationContainer = "_o2-1";
export var footer = "_o2-2";
export var lineItems = "_o2-3";
export var modalContent = "_o2-4";
export var orderName = "_o2-5";
export var strong = "_o2-6";
export var warning = "_o2-7";